<template>
  <div class="message-container"
       @click="dialogVisible=true">
    <img src="http://member.intelliquor.com/zy/message.png"
         alt="">
    <i v-if="total>0">{{total}}</i>
    <span class="rule"></span>
    <appMessageDialog :total.sync="total" :dialogVisible.sync="dialogVisible"/>

  </div>
</template>

<script>

import appMessageDialog from './app-message-dialog.vue'
export default {
  components:{
    appMessageDialog
  },
  data() {
    return {
      total:0,
      dialogVisible: false,
    }
  },
  mounted(){
    // this.dialogVisible = false
  }
  
}
</script>


<style scoped>

.message-container {
  float: right;
  margin-right: 55px;
  color: #fff;
  position: relative;
  cursor: pointer;
}
img {
  width: 17px;
  height: 18px;
}
i {
  position: absolute;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #ffc06a;
  font-size: 10px;
  color: #002649;
  line-height: 12px;
  text-align: center;
  font-style: normal;
  top: 15px;
}
.rule{
  display: inline-block;
  width: 1px;
  height: 28px;
  background: #EBEBF2;
  margin-left: 20px;
  position: absolute;
  left: 20px;
  top: 17px;
}
</style>
